import { Component, Input } from '@angular/core';
import { Field } from '@sb-tools/typescript/models/field.model';
import { ClientField } from '@form-field-module/common/models/client-field.model';

@Component({
    selector: 'sb-form-field-label',
    imports: [],
    templateUrl: './form-field-label.component.html',
    styleUrl: './form-field-label.component.scss',
})
export class FormFieldLabelComponent {
    @Input() formField: Field | ClientField;
    @Input() labelForPostfix: string = '';
}
